export default {
  strict: true,
  namespaced: true,
  state: {
    view: {
      details: {},
      list: [],
      loading: false,
      currentPage: 1,
      perPage: 20,
      order: 'id',
      orderAsc: 0,
      maxList: 0,
      saving: false
    }
  },
  mutations: {
    setViewDetails (state, value) { state.view.details = value },
    setViewList (state, value) { state.view.list = value },
    setViewLoading (state, value) { state.view.loading = value },
    setViewCurrentPage (state, value) { state.view.currentPage = value },
    setViewPerPage (state, value) { state.view.perPage = value },
    setViewOrder (state, value) { state.view.order = value },
    setViewOrderAsc (state, value) { state.view.orderAsc = value },
    setViewMaxList (state, value) { state.view.maxList = value },
    setViewSaving (state, value) { state.view.saving = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/promo/view-list.js